import { Grid } from "@material-ui/core";
import { Sync } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { prettifyDate } from "../../../helpers/prettify-date";
import { prettifyTime } from "../../../helpers/prettify-time";
import { HttpClient } from "../../../web-services/http-client";
import { IParkingLotData } from "../../../web-services/models/parking-lot-data";
import { objectToFormData } from "../../../web-services/utils/object-to-form-data";
import { DataGetterCard } from "../data-getter-card";
import { ParkingLotTable } from "../parking-lot-table";
import { ProgressDialog } from "../progress-dialog";
import { IVjtData } from "../../../web-services/models/vjt-data";
import { ParkingLotEditDialog } from "./parking-lot-edit-dialog";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function TableBlock(props: {
    httpClient: HttpClient;
    parkingLotId: number;
    selectedStartDate: Date;
    selectedStartTime: Date | undefined;
    selectedEndDate: Date;
    selectedEndTime: Date | undefined;
    handleStartDateChange: (date: any) => void;
    handleStartTimeChange: (date: any) => void;
    handleEndDateChange: (date: any) => void;
    handleEndTimeChange: (date: any) => void;
})
{
    const [tableData, setTableData] = useState<IParkingLotData[]>([]);
    const [latestTableData, setLatestTableData] = useState<IParkingLotData[]>([]);
    const [errorMsg, setErrorMsg] = useState<string>();
    const [errorCategoryMsg, setErrorCategoryMsg] = useState<string>();
    const [isSendingRequest, setIsSendingRequest] = useState<boolean>(true);
    const [progressDialogOpened, setProgressDialogOpened] = useState<boolean>(false);
    const [parkingLotDialogOpened, setParkingLotDialogOpened] = useState<boolean>(false);
    const [selectedParkingLot, setSelectedParkingLot] = useState<IParkingLotData>();
    const [modifiable, setModifiable] = useState<boolean>(false);

    const getLatestTableData = async () =>
    {
        try
        {
            let data = (await props.httpClient.post<IParkingLotData[]>(
                "values/post-latest-data",
                "",
                objectToFormData({
                    parkingLotId: props.parkingLotId
                }),
                15000
            )).data;
            setLatestTableData(data || []);
            setProgressDialogOpened(false);
            setParkingLotDialogOpened(false);
            setModifiable(data[0].modifiable);
            setSelectedParkingLot(data[0]);
        }
        catch (err: any)
        {
            console.log(err);

            if (err.message === "Nem várt hiba történt.")
            {
                setErrorCategoryMsg("Kapcsolati hiba");
                setErrorMsg("Kérjük, próbálja újra az adatlekérést.");
            }
            else
            {
                setErrorMsg(err.message);
            }
        }
    };

    useEffect(() =>
    {
        if (!isSendingRequest) return;
        setProgressDialogOpened(true);

        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            setErrorCategoryMsg(undefined);
            try
            {
                let data = (await props.httpClient.post<IParkingLotData[]>(
                    "values/post-table-data",
                    "",
                    objectToFormData({
                        parkingLotId: props.parkingLotId,
                        startDate: prettifyDate(props.selectedStartDate),
                        endDate: prettifyDate(props.selectedEndDate),
                        startTime: prettifyTime(props.selectedStartTime),
                        endTime: prettifyTime(props.selectedEndTime)
                    }),
                    15000
                )).data;
                setTableData(data || []);
                setProgressDialogOpened(false);
            }
            catch (err: any)
            {
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorCategoryMsg("Kapcsolati hiba");
                    setErrorMsg("Kérjük, próbálja újra az adatlekérést.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }

            if (latestTableData.length === 0)
            {
                getLatestTableData();
            }

            let interval = setInterval(async() =>
            {
                getLatestTableData();
            }, 60 * 5 * 1000);

            setIsSendingRequest(false);

            return () =>
            {
                clearInterval(interval);
            };
        };

        fetchData().catch(console.error);

    }, [isSendingRequest]);
    const handleSaveSuccess = () =>
    {
        setParkingLotDialogOpened(false);
        getLatestTableData();
    };
    const handleModifiableButtonClick = () =>
    {
        setParkingLotDialogOpened(true);
    };
    return (
        <>
            <ParkingLotEditDialog
                parkingLot={selectedParkingLot}
                httpClient={props.httpClient}
                parkingLotId={props.parkingLotId}
                open={parkingLotDialogOpened}
                onClose={() => setParkingLotDialogOpened(false)}
                onSaveSuccess={handleSaveSuccess}
            />


            <ProgressDialog
                text="Adatbetöltés folyamatban"
                retryButtonText="Újra lekérem"
                onRetryButtonClick={() => setIsSendingRequest(true)}
                onCancelButtonClick={() => setProgressDialogOpened(false)}
                retryButtonIcon={<Sync />}
                errorText={errorMsg}
                errorCategoryText={errorCategoryMsg}
                open={progressDialogOpened}
            />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <ParkingLotTable data={latestTableData} allPlacesVisible />
                    <DataGetterCard
                        startDate={props.selectedStartDate}
                        startTime={props.selectedStartTime}
                        endDate={props.selectedEndDate}
                        endTime={props.selectedEndTime}
                        modifiable={modifiable}
                        onButtonClick={() => setIsSendingRequest(true)}
                        onStartDateChange={props.handleStartDateChange}
                        onStartTimeChange={props.handleStartTimeChange}
                        onEndDateChange={props.handleEndDateChange}
                        onEndTimeChange={props.handleEndTimeChange}
                        onModifyButtonClick={handleModifiableButtonClick}
                    />
                    <ParkingLotTable data={tableData} />
                </Grid>
            </Grid>
        </>
    );
}
